module.exports = __webpack_public_path__ + "img/tradecommencementmeetings_smpost.1efead38.png";